import { render } from "./Presets.vue?vue&type=template&id=f6bd8b1e&scoped=true"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"

import "./Presets.vue?vue&type=style&index=0&id=f6bd8b1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6bd8b1e"]])

export default __exports__